module.exports = __webpack_public_path__ + "media/topic-to-nugget.7d3fd873.wav";